'use client';

import { useSiteConfig } from '@commons/SiteConfig';

export default function useDictionary() {
  const ctx = useSiteConfig();

  return { dictionary: ctx?.dictionary || {}, isLoading: false };
}
